import clsx from "clsx";
import { ReactNode } from "react";
import { Tooltip } from "../tooltip";
import styles from "./stat-card.module.scss";

export type StatCardDisplayType = "expanded" | "compact";

interface StatCardProps {
  title: string;
  value: ReactNode;
  tooltip?: ReactNode;
  displayType?: StatCardDisplayType;
}

const StatCard = ({
  title,
  value,
  tooltip,
  displayType = "expanded"
}: StatCardProps) => {
  const card = (
    <div
      className={clsx(styles.card, styles[displayType])}
      data-testid="stat-card"
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );

  if (!tooltip) {
    return card;
  }

  return (
    <Tooltip content={tooltip} placement="top" innerAs="div">
      {card}
    </Tooltip>
  );
};

export default StatCard;
